import React from 'react';
import { Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import Image from 'next/image';

export const About4 = () => {
  const [width, setWidth] = React.useState('');
  React.useEffect(() => {
    const { innerWidth: width } = window;
    setWidth(width);
  }, []);
  return (
    <div className="about-main-container">
      <div className="container">
        <Stack spacing={3} className="about-stack about-4-stack">
          <div className="about-title about-title-4">Here’s an example</div>
          <Typography className="about-description about-description-4">
            If a musician is able to get a thousand of their fans to stream on
            Spotify, they may make about $4. That’s it. On MusicArt, a musician
            can release, say, 100 NFT editions of that same music, and price
            those NFTs at $4 each. If you have 100 enthusiastic fans, you’d make
            $400 from that release… and the whole process would only cost you
            $19.90
          </Typography>
          <Typography className="about-footer">
            We call those charges “set-up fees,” and you only pay them once, for
            everything you post for sale on MusicArt. You can even use PayPal or
            a credit/debit card.
          </Typography>
          <div
            className="flex flex-col items-center justify-center stack-image"
            style={{
              paddingTop: '2rem',
              paddingBottom: '2rem',
            }}
          >
            <Stack className="flex flex-col items-center justify-center">
              <Image
                src={'/img/about/spotify-banner.png'}
                height={width > 2000 ? 160 : 80}
                width={width > 2000 ? 500 : 300}
                objectFit="contain"
              />
              <Typography className="about-label-text">
                1000 Streams = $4*
              </Typography>
            </Stack>
            <Stack
              className="flex flex-col items-center justify-center"
              style={{
                paddingTop: '1rem',
              }}
            >
              <Image
                src={'/img/about/MusicArtLogo2.png'}
                height={width > 2000 ? 160 : 80}
                width={width > 2000 ? 500 : 300}
                objectFit="contain"
              />
              <Typography className="about-label-text">
                100 NFT Sales = $400**
              </Typography>
            </Stack>
          </div>
          <Stack spacing={1}>
            <Typography className="footer_note">
              *This is an estimate based on most recent streaming data.
            </Typography>
            <Typography className="footer_note">
              **This is only an example, actual amounts will depend on your
              pricing.
            </Typography>
          </Stack>
        </Stack>
      </div>
    </div>
  );
};
